import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Platform, Text, View, StatusBar, StyleSheet, TouchableOpacity } from 'react-native';
import Colors from '../../constants/Colors';
import Svg from '../Svg';

class Header extends Component {
  static propTypes = {
    titel: PropTypes.string,
    goBack: PropTypes.func,
  };

  render() {
    const { goBack, title } = this.props;
    const headerBackGround = {};
    if (Platform.OS === 'web') {
      headerBackGround.boxShadow = '0px 0px 10px rgba(0, 0, 0, 0.1)';
      headerBackGround.zIndex = 1;
    }
    const spacer = (
      <View style={styles.spacer}>
        <Text> </Text>
      </View>
    );

    return (
      <>
        {Platform.OS === 'ios' && <StatusBar barStyle="light-content" backgroundColor={Colors.mediumBlue} />}
        <View style={[styles.header, headerBackGround]}>
          {Platform.OS !== 'web' && goBack ? (
            <TouchableOpacity onPress={goBack}>
              <Svg color="white" icon="arrow_back" width={24} height={24} />
            </TouchableOpacity>
          ) : (
            spacer
          )}
          {title ? (
            <Text style={styles.headerText} numberOfLines={1}>
              {title}
            </Text>
          ) : (
            spacer
          )}
          {spacer}
        </View>
      </>
    );
  }
}

const styles = StyleSheet.create({
  header: {
    height: 56,
    minHeight: 56,
    width: '100%',
    paddingHorizontal: 16,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: Platform.OS === 'web' ? Colors.white : Colors.mediumBlue,
  },
  headerText: {
    fontSize: 20,
    fontWeight: '500',
    color: Platform.OS === 'web' ? Colors.mediumBlue : Colors.white,
    marginRight: 32,
    marginLeft: 16,
  },
  spacer: {
    width: 24,
  },
});

export default Header;
